/*
 * Public API Surface of ngx-pinch-zoom
 */

export * from './lib/interfaces';
export * from './lib/pinch-zoom.module';
export * from './lib/pinch-zoom.component';
